import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { Context } from "../../../contexts/Store";
import { baseConfig } from "../../../utils/config";

export default function TopicAddModal({
    isOpen,
    onClose,
    type,
    reload,
    setReload,
    slug,
    editTopic,
    TopicData,
}) {
    const { state } = useContext(Context);
    let access_token = state.user_details.access_token;

    const [topic, setTopic] = useState({
        title: "",
        isLoading: false,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setTopic({
            ...topic,
            [name]: value,
        });
    };

    const handleSaveCourse = async () => {
        setTopic((prev) => ({ ...prev, isLoading: true }));
        try {
            const formData = new FormData();
            formData.append("title", topic.title);
            formData.append("course", slug);

            let url = `free-courses/topics/`;
            let method = baseConfig.post;

            if (editTopic === "edit" && TopicData) {
                url = `free-courses/topics/${TopicData.id}/`;
                method = baseConfig.put;
            }

            const response = await method(url, formData, {
                headers: {
                    Authorization: "Bearer " + access_token,
                    "Content-Type": "multipart/form-data",
                },
            });

            const { StatusCode } = response.data;
            if (StatusCode === 6000) {
                setReload(!reload);
                handleClear();
                onClose();
            }
        } catch (error) {
            if (error?.response?.data?.code === "token_not_valid") {
                    localStorage.clear();
                    window.location = "/";
                }
            console.error("Error:", error);
        } finally {
            setTopic((prev) => ({ ...prev, isLoading: false }));
        }
    };

    useEffect(() => {
        if (editTopic === "edit" && TopicData) {
            setTopic({
                title: TopicData.title || "",
                isLoading: false,
            });
        }
    }, [editTopic]);

    const handleClear = () => {
        setTopic({
            title: "",
            isLoading: false,
        });
    };

    if (!isOpen) return null;

    return (
        <>
            <ModalOverlay>
                <ModalContainer>
                    <ModalHeader>
                        <ModalTitle>
                            {type === "edit" ? "Edit Topic" : " Add Topic"}
                        </ModalTitle>
                    </ModalHeader>
                    <FormGroup>
                        <Label>Title</Label>
                        <Input
                            type="text"
                            name="title"
                            placeholder="Enter title"
                            value={topic.title}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                    <ModalFooter>
                        <CancelButton
                            onClick={() => {
                                handleClear();
                                onClose();
                            }}
                        >
                            Cancel
                        </CancelButton>
                        <AddButton onClick={handleSaveCourse}>
                            {topic?.isLoading ? "Saving..." : "Save"}
                        </AddButton>
                    </ModalFooter>
                </ModalContainer>
            </ModalOverlay>
        </>
    );
}

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.57);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

const ModalContainer = styled.div`
    background-color: white;
    border-radius: 10px;
    width: 600px;
    max-width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2),
        0px 5px 15px rgba(0, 0, 0, 0.1);
    padding: 20px;
`;

const ModalHeader = styled.div`
    border-bottom: 1px solid #c1c1c1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
`;

const ModalTitle = styled.h2`
    font-size: 24px;
    font-weight: 500;
    color: #010101;
    margin-bottom: 20px;
`;
const Label = styled.label`
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 16px;
    color: #000;
`;

const FormGroup = styled.div`
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
`;

const Input = styled.input`
    width: calc(100% - 0px);
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #5a2d8f;
    }

    &::placeholder {
        color: #9d9d9d;
        font-size: 14px;
        font-weight: 300;
    }
`;

const ModalFooter = styled.div`
    padding-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

const CancelButton = styled.button`
    background-color: white;
    color: #333;
    border: 1px solid #ccc;
    padding: 12px 24px;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: #f5f5f5;
    }
`;

const AddButton = styled.button`
    background-color: #5a2d8f;
    color: white;
    border: none;
    padding: 12px 40px;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: #4a2575;
    }
`;
